import { render } from "./FrameDetailsTab.vue?vue&type=template&id=f578f47a&scoped=true"
import script from "./FrameDetailsTab.vue?vue&type=script&lang=js"
export * from "./FrameDetailsTab.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=f578f47a&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f578f47a"]])

export default __exports__